<template>
	<div class="page-select-div clear-float">
		<ul>
			<li>
				<router-link to="/home/keywordTop">TOP100</router-link>
			</li>
			<li>
				<router-link to="/home/weekly_keyword">关键词</router-link>
			</li>
			<!-- <li>
				<router-link to="/home/weekly_asin">ASIN反查</router-link>
			</li> -->
			<!-- <li> -->
				<!-- <router-link to="/home/keywordsByAsin">asin走势</router-link> -->
			<!-- </li> -->
		</ul>
	</div>
</template>

<script>
export default {
	name: 'copySub',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg'],
	data() {return {
	}},
	methods:{
		onCopy : function(){
			this.F_alertMsg('复制成功',2)
		},
		onError : function(){
			this.F_alertMsg('复制错误',3)
		},
	},
	watch: {},	
}
</script>

<style scoped>

.page-select-div ul{
	float: right;
}
.page-select-div ul li{
	list-style: none;
	width: 100px;
	text-align: center;
	float: left;
	line-height: 30px;
}
.page-select-div ul li a{
	color: #2b7cd9;
}
.page-select-div ul li:hover{
	background-color: #E4E7ED;
}
</style>
